import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PRODUCTS } from "@/data/products";

const CODES = ["arw0008st", "arw000bt", "ar0008msl", "ar0008mst"];

export default function DenimReview() {
  const items = CODES.map((c) => PRODUCTS.find((p) => p.id === c)).filter(Boolean);
  return (
    <div data-testid="denim-review" className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12 py-10 lg:py-16">
      <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-denim">Accuracy Review · Step 1</p>
      <h1 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight">Denim Accuracy Check</h1>
      <p className="mt-4 text-muted-foreground max-w-2xl text-sm leading-relaxed">
        The four core denim styles, corrected to match the official AR / American Rag references.
        Each pair shows the original reference sheet image (left) beside the new model photograph (right),
        generated directly from that reference to preserve silhouette, rise, leg opening and wash.
      </p>

      <div className="mt-10 space-y-12">
        {items.map((p) => (
          <div key={p.id} data-testid={`review-${p.id}`} className="border border-border bg-white">
            <div className="flex flex-wrap items-center justify-between gap-2 px-5 py-4 border-b border-border bg-offwhite">
              <div>
                <span className="font-mono text-[12px] uppercase tracking-widest text-denim">{p.styleCode}</span>
                <h2 className="font-heading font-bold uppercase tracking-wide text-base">{p.name}</h2>
              </div>
              <span className="text-xs text-muted-foreground">{p.gender} · {p.name} · {p.washes.length} washes</span>
            </div>
            <div className="grid grid-cols-2">
              <figure className="border-r border-border">
                <div className="bg-sand aspect-[3/4] overflow-hidden">
                  <img src={p.cadRef} alt={`${p.styleCode} reference`} className="w-full h-full object-contain" />
                </div>
                <figcaption className="px-4 py-3 text-xs font-mono uppercase tracking-widest text-muted-foreground">Original Reference</figcaption>
              </figure>
              <figure>
                <div className="bg-sand aspect-[3/4] overflow-hidden">
                  <img src={p.image} alt={`${p.styleCode} new model`} className="w-full h-full object-cover object-top" />
                </div>
                <figcaption className="px-4 py-3 text-xs font-mono uppercase tracking-widest text-ink flex items-center gap-1.5">
                  <Check className="w-3.5 h-3.5 text-denim" /> New Model Image
                </figcaption>
              </figure>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-navy text-white p-7 lg:p-10 text-center">
        <h3 className="font-display text-2xl font-bold uppercase tracking-tight">Approve to continue</h3>
        <p className="mt-3 text-white/60 text-sm max-w-xl mx-auto">
          Once you approve these four denim styles, I'll apply the same reference-accurate treatment across the full
          tees, hoodies and fleece collection. Review the live denim pages below.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/women-denim" className="bg-white text-ink px-6 py-3 text-xs font-bold uppercase tracking-widest hover:bg-denim hover:text-white transition-colors">View Women's Denim</Link>
          <Link to="/men-denim" className="border border-white/40 px-6 py-3 text-xs font-bold uppercase tracking-widest hover:bg-white hover:text-ink transition-colors">View Men's Denim</Link>
        </div>
      </div>
    </div>
  );
}
